import React, { useState, useEffect } from "react";
import { Anchor } from 'antd';
import { FaArrowUp } from "react-icons/fa"; // Top arrow ke liye icon

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showScrollTop, setShowScrollTop] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Scroll position track karne ke liye useEffect lagaya
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollTop(true); // Agar 300px se zyada scroll kiya toh arrow dikhao
            } else {
                setShowScrollTop(false); // Warna chhupa do
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Smoothly top par scroll karne ka function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <>
            {/* 1. Yeh empty div pure page ka top pointer hai, Home link isi par target karega */}
            <div id="home-top" />

            <div className="header">
                <div className="container">
                    <div className="header-inner">
                        {/* Logo Section */}
                        <div className="header-img">
                            <a href="#home-top">
                                <img src="../assets/img/logo-light-1.png" alt="logo" />
                            </a>
                        </div>

                        {/* Mobile Hamburger Icon */}
                        <div className={`menu-toggle ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

                        {/* Navigation Menu */}
                        <div className={`nav-menu-wrapper ${isMenuOpen ? 'active' : ''}`}>
                            <Anchor
                                /* Mobile par vertical menu layout chalega aur desktop par horizontal */
                                direction={window.innerWidth < 991 ? "vertical" : "horizontal"}
                                onClick={() => setIsMenuOpen(false)}
                                items={[
                                    { key: 'part-1', href: '#home-top', title: 'Home' }, // Fixed Target
                                    { key: 'part-2', href: '#about', title: 'About' },
                                    { key: 'part-3', href: '#Services', title: 'Services' },
                                    { key: 'part-4', href: '#Portfolio', title: 'Portfolio' },
                                    { key: 'part-5', href: '#Review', title: 'Testimonials' },
                                    { key: 'part-6', href: '#Pricing', title: 'Pricing' },
                                    { key: 'part-7', href: '#Latest', title: 'Blog' },
                                    { key: 'part-8', href: '#Contact', title: 'Contact' },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 2. Scroll-to-Top Button Component */}
            <div
                className={`scroll-to-top-btn ${showScrollTop ? 'visible' : ''}`}
                onClick={scrollToTop}
                title="Go to Top"
            >
                <FaArrowUp />
            </div>
        </>
    );
}

export default Header;